module.exports = __webpack_public_path__ + "img/Google.b096543d.svg";